interface BlogHeaderProps {
	title?: string;
	heading: string;
	description?: string;
	image?: string;
	imageAlt?: string;
	credit?: string;
}

export function BlogHeader({
	title,
	heading,
	description,
	image,
	imageAlt,
	credit,
}: BlogHeaderProps) {
	if (image) {
		return (
			<header className="relative mb-10 overflow-hidden rounded-2xl border border-border/80 bg-card shadow-md dark:shadow-none">
				<div className="relative max-h-[min(42vh,18rem)] w-full overflow-hidden sm:max-h-[min(45vh,22rem)]">
					<img
						src={image}
						alt={imageAlt || heading}
						className="h-full w-full object-cover"
					/>
					<div className="absolute inset-0 bg-linear-to-t from-background via-background/75 to-background/20" />
					<div className="absolute inset-0 flex flex-col justify-end p-6 sm:p-8">
						{title ? (
							<p className="text-sm font-medium text-primary">{title}</p>
						) : null}
						<h1 className="mt-1 max-w-[90%] text-balance text-3xl font-semibold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
							{heading}
						</h1>
						{description ? (
							<p
								className="mt-3 max-w-2xl text-pretty text-base text-muted-foreground sm:text-lg"
								// biome-ignore lint/security/noDangerouslySetInnerHtml: This is purely for marketing purposes and does not take user input.
								dangerouslySetInnerHTML={{ __html: description }}
							/>
						) : null}
					</div>
					{credit ? (
						<div className="absolute bottom-3 right-3 z-10">
							<span className="rounded-md bg-background/80 px-2 py-1 text-xs text-muted-foreground backdrop-blur-sm">
								{credit}
							</span>
						</div>
					) : null}
				</div>
			</header>
		);
	}

	return (
		<header className="mb-10 border-b border-border/80 pb-10">
			{title ? (
				<p className="text-sm font-medium text-primary">{title}</p>
			) : null}
			<h1 className="mt-2 max-w-3xl text-balance text-3xl font-semibold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
				{heading}
			</h1>
			{description ? (
				<p
					className="mt-4 max-w-2xl text-pretty text-base text-muted-foreground sm:text-lg"
					// biome-ignore lint/security/noDangerouslySetInnerHtml: This is purely for marketing purposes and does not take user input.
					dangerouslySetInnerHTML={{ __html: description }}
				/>
			) : null}
		</header>
	);
}
